import { configureStore } from '@reduxjs/toolkit';
import authReducer, { loadUserFromStorage } from './slices/authSlice';
import packageReducer from './slices/packageSlice';
import accountsReducer from './slices/accountsSlice';
import resellersReducer from './slices/resellerSlice';


export const store = configureStore({
  reducer: {
    auth: authReducer,
    packages: packageReducer,
    accounts: accountsReducer,
    resellers: resellersReducer,
  },
});
store.dispatch(loadUserFromStorage());
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
